/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import React from "react";
import { Button, ButtonGroup, Tooltip } from "@mui/material";
import { styled } from "@mui/material/styles";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import MDTypography from "components/MDTypography";

const BotonEstado = styled(Button)(({ activecolor }) => ({
  backgroundColor: activecolor || "#1a2035",
  borderColor: activecolor || "#1a2035",
  color: "#fff",
  minWidth: "40px",
  padding: "6px",
  "&:hover": {
    backgroundColor: activecolor || "#1a2035",
  },
}));

const GrupoBotonesEstatusArchivos = ({ estatus, onSeleccion,validadoPor }) => {
  const obtenerColor = (valor) => {
    switch (valor) {
      case 0:
        return estatus === 0 ? "#F58020" : "#1a2035"; // En revisión
      case 1:
        return estatus === 1 ? "#388e3c" : "#1a2035"; // Validada
      case 2:
        return estatus === 2 ? "#d32f2f" : "#1a2035"; // Rechazada
      default:
        return "#1a2035";
    }
  };

    const obtenerTextoEstatus = () => {
    switch (estatus) {
      case 0:
        return "En revisión";
      case 1:
        return validadoPor ? "Validada por ".concat(validadoPor)  : "Validada";
      case 2:
        return "Rechazada";
      default:
        return "Sin estatus";
    }
  };

  return (
  <>
      <ButtonGroup disableElevation aria-label="Botones estatus documento">
      <Tooltip title="En revisión">
        <BotonEstado
          activecolor={obtenerColor(0)}
          onClick={() => onSeleccion(0)}
        >
          <AccessTimeIcon sx={{ color: "#fff" }} />
        </BotonEstado>
      </Tooltip>

      <Tooltip title="Validada">
        <BotonEstado
          activecolor={obtenerColor(1)}
          onClick={() => onSeleccion(1)}
        >
          <CheckCircleIcon sx={{ color: "#fff" }} />
        </BotonEstado>
      </Tooltip>

      <Tooltip title="Rechazada">
        <BotonEstado
          activecolor={obtenerColor(2)}
          onClick={() => onSeleccion(2)}
        >
          <CloseIcon sx={{ color: "#fff" }} />
        </BotonEstado>
      </Tooltip>
    </ButtonGroup>
     <MDTypography
        variant="text"
        color="white"
        style={{ opacity: 0.7, fontSize: 12 }}
      >
        {obtenerTextoEstatus()}
      </MDTypography>
  </>
  );
};

export default GrupoBotonesEstatusArchivos;
